import { render, staticRenderFns } from "./VCurrencyField.vue?vue&type=template&id=d5a1c76e"
import script from "./VCurrencyField.vue?vue&type=script&lang=ts"
export * from "./VCurrencyField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports